import React from "react";
import Button from "./Button.jsx";
import GenericUtils from "../../lib_react_frontend/utils/GenericUtils.jsx";

export default class Modal extends React.Component {
  // Id sequencial para não repetir o ID no dom node:
  static seqId = 0;

  constructor() {
    super();
    this.uniqueId = "modal-" + Modal.seqId++;
    this.modalFecha = [];
  }

  // Props closeOnEsc e confirmOnF2 foram implementadas por requisito da gerencia, onde
  // o modal deve ser fechado quando o usuário utilizar a tecla esc, e confirmado quando o mesmo
  // utilizar a tecla F2.
  // onKeyDown(e) {
  //   if (e.key === 'Escape') {
  //     if (this.props.closeOnEsc) {
  //       this.hide();
  //     }
  //   } else if (e.key === 'F2') {
  //     if (this.props.confirmOnF2) {
  //       this.props.confirmOnF2();
  //     }
  //   }
  // }

  /**
   * Mostra esse dialog na tela
   */
  show() {
    let modal = [];
    if (global.modais) {
      modal = global.modais;
    }
    modal.push(this.uniqueId);
    global.modais = modal;
    window.$("#" + this.uniqueId).modal("show");
    if (this.props.idModal) {
      this.props.idModal(this.uniqueId);
    }
  }

  /**
   * Esconde esse dialog da tela
   */
  hide() {
    if (global.modais) {
      const modais = global.modais;
      const modalFechar = global.modais[global.modais.length - 1];
      modais.splice(global.modais.length - 1, 1);
      window.$("#" + modalFechar).modal("hide");
    }

    if (this.props.onHide) {
      this.props.onHide();
    }
  }

  hideModal() {
    if (global.modais) {
      const modais = global.modais;
      const modalFechar = global.modais[global.modais.length - 1];
      modais.splice(global.modais.length - 1, 1);
      window.$("#" + modalFechar).modal("hide");
    }

    if (this.props.onHide) {
      this.props.onHide();
    }
  }

  marca() {
    if (this.props.marcarTodos) {
      this.props.marcarTodos();
    }
  }

  desmarca() {
    if (this.props.desmarcaTodos) {
      this.props.desmarcaTodos();
    }
  }

  render() {
    return (
      <div
        className="modal fade"
        id={this.uniqueId}
        tabIndex="-1"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
        style={this.props.styleModalFade}
        //  onKeyDown={this.onKeyDown.bind(this)}
        onKeyDown={this.props.modalOnKeyDown}
      >
        <div
          className={
            "modal-dialog modalAlterar " +
            this.props.passado +
            " " +
            this.props.className
          }
          role="document"
          style={this.props.style}
        >
          <div
            className={
              GenericUtils.isMobile()
                ? "modal-contentmodal-ios"
                : "modal-contentmodal"
            }
            style={
              this.props.style
                ? { ...this.props.style, width: "100%" }
                : { width: "100%" }
            }
          >
            {/* Cabeçalho */}
            <div className="modal-header">
              {!this.props.semfecha && (
                <Button
                  className="close"
                  data-dismiss="modal"
                  onClick={
                    this.props.onFecha ? this.props.onFecha : this.props.onHide
                  }
                  icon="fa-times"
                />
              )}
              {this.props.link_ajuda && (
                <Button
                  className="ajudar"
                  onClick={() =>
                    window.open(this.props.link_ajuda, "BiggerMap")
                  }
                  icon="fa-question"
                />
              )}
              <h4
                className="modal-title"
                id="myModalLabel"
                style={this.props.titleStyle}
              >
                {this.props.title || ""}
              </h4>
            </div>

            <div className={"modal-body "}>{this.props.children}</div>

            {/* Rodapé: */}
            {this.props.buttons && this.props.buttons.length > 0 && (
              <div className="modal-footer">
                {this.props.buttons.map((x) => (
                  <Button
                    className={x.className}
                    key={x.label}
                    icon={x.icon}
                    disabled={x.disabled}
                    style={
                      x.style == "botaoEsquerda"
                        ? { float: "left" }
                        : x.style
                        ? x.style
                        : null
                    }
                    onKeyDown={x.onKeyDown ? x.onKeyDown : ""}
                    hidden={x.hidden ? x.hidden() : false}
                    onClick={() => {
                      if (x.onClick) x.onClick();
                      if (x.dismiss) this.hide();
                    }}
                    label={x.label}
                  />
                ))}

                {this.props.marcadores && (
                  <div>
                    {this.props.marca_todos ? (
                      <Button
                        hidden={this.props.onHide}
                        style={{ float: "left", marginTop: "-32px" }}
                        onClick={() => this.marca()}
                        title="Marcar todos"
                        icon="fa-check-square-o"
                      />
                    ) : (
                      <Button
                        hidden={this.props.onHide}
                        style={{ float: "left", marginTop: "-32px" }}
                        onClick={() => this.desmarca()}
                        title="Desmarcar Todos"
                        icon="fa-window-close"
                      />
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Rodapé de botões com ref: */}
            {this.props.refButtons && this.props.refButtons.length > 0 && (
              <div className="modal-footer">
                {this.props.refButtons}

                {this.props.marcadores && (
                  <div>
                    {this.props.marca_todos ? (
                      <Button
                        hidden={this.props.onHide}
                        style={{ float: "left", marginTop: "-32px" }}
                        onClick={() => this.marca()}
                        title="Marcar todos"
                        icon="fa-check-square-o"
                      />
                    ) : (
                      <Button
                        hidden={this.props.onHide}
                        style={{ float: "left", marginTop: "-32px" }}
                        onClick={() => this.desmarca()}
                        title="Desmarcar Todos"
                        icon="fa-window-close"
                      />
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/Modal.jsx